export default [{
  path: '/admin/institution/staff/list',
  name: 'institutionStaffList',
  component: () => import('@/views/institution/staff/list/index'),
  meta: {
    title: '人员管理',
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/staff/role/list',
  name: 'institutionStaffRoleList',
  component: () => import('@/views/institution/staff/role/list/index'),
  meta: {
    title: '角色管理',
    headType: 2,
    auth: true,
    routerType: 2
  }
}]



// WEBPACK FOOTER //
// ./src/router/institution/staff.js